import { Reveal } from "@/components/motion";

const chapters = [
  {
    n: "01",
    title: "A vision built on trust",
    body: "For the families of Jammu, Shah Eye Care Centre is more than a clinic — it is a promise. Every examination, every surgery, every follow-up is guided by honesty and genuine care.",
  },
  {
    n: "02",
    title: "Precision meets compassion",
    body: "We pair the most advanced diagnostics — OCT, FFA, Corneal Topography, Pachymetry — with unhurried, human conversations, so you always understand your eyes and your options.",
  },
  {
    n: "03",
    title: "Care that stays with you",
    body: "From premium-IOL Phaco cataract surgery to LASIK, C3R and retina management, our specialists walk with you long after you leave the chair. Your vision is a lifelong relationship.",
  },
];

export default function About() {
  return (
    <section id="about" className="relative py-24 sm:py-32 bg-[var(--bg)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="text-[var(--teal)] text-sm tracking-[0.25em] uppercase mb-5">Our Vision</p>
              <h2 className="font-display text-4xl sm:text-5xl md:text-6xl leading-[1.05] tracking-tight text-[var(--ink)]">
                Clarity, care and craft — in every eye we treat.
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-10 rounded-3xl overflow-hidden shadow-[0_20px_50px_rgb(13,122,122,0.15)]">
                <img src="/assets/clinic.png" alt="Clinic exterior" className="w-full h-72 lg:h-96 object-cover" />
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-6 lg:col-start-7 flex flex-col justify-center">
            <div className="space-y-12">
              {chapters.map((c, i) => (
                <Reveal key={c.n} delay={i * 0.1}>
                  <div className="flex gap-6 border-b border-border pb-10 last:border-0">
                    <span className="font-display text-3xl text-[var(--teal)]/40 shrink-0">{c.n}</span>
                    <div>
                      <h3 className="font-display text-2xl sm:text-3xl text-[var(--ink)] mb-3">{c.title}</h3>
                      <p className="text-[var(--ink-soft)] leading-relaxed">{c.body}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
